import {Act} from '@gongxigames/framework/slotV2/fsm/acts/Act';
import {SequenceAct} from '@gongxigames/framework/slotV2/fsm/acts/SequenceAct';
import {ParallelAct} from '@gongxigames/framework/slotV2/fsm/acts/ParallelAct';
import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {ListenerActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/ListenerActDecorator';
import {AsyncAct} from '@gongxigames/framework/slotV2/fsm/acts/AsyncAct';
import {ListenerAct} from '@gongxigames/framework/slotV2/fsm/acts/ListenerAct';
import {ActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/ActDecorator';
import {CycledActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/CycledActDecorator';
import {CycledAct} from '@gongxigames/framework/slotV2/fsm/acts/CycledAct';
import {SyncUIAct} from '@gongxigames/framework/slotV2/fsm/acts/SyncUIAct';
import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export type ActDecoratorConstructor = new () => ActDecorator;
export type ActConstructor = new () => Act;

function isClass(obj: ActDecoratorConstructor | SequenceAct | ParallelAct) {
    return typeof obj === 'function';
}
function createAct(constructor: ActDecoratorConstructor): Act {
    const decorator = new constructor();
    let act: AsyncAct | ListenerAct | CycledAct | SyncUIAct;

    if (decorator instanceof AsyncActDecorator) {
        act = new AsyncAct();
        act.decoratorAct = decorator as AsyncActDecorator;

        return act;
    }

    if (decorator instanceof ListenerActDecorator) {
        act = new ListenerAct();
        act.decoratorAct = decorator as ListenerActDecorator;

        return act;
    }

    if (decorator instanceof CycledActDecorator) {
        act = new CycledAct();
        act.decoratorAct = decorator as CycledActDecorator;

        return act;
    }

    if (decorator instanceof SyncUIActDecorator) {
        act = new SyncUIAct();
        act.decoratorAct = decorator as SyncUIActDecorator;

        return act;
    }

    throw new Error('constructor of actDecorator is not valid');
}

function createActs(items: (ActDecoratorConstructor | SequenceAct | ParallelAct)[]): Act[] {
    return items.map(item => isClass(item) ? createAct(item as ActDecoratorConstructor) : item as Act);
}

/**
 * Use SequenceAct as container for a chain of Acts.
 * It is await like behaviour.
 */
export function sequence(items: (ActDecoratorConstructor | SequenceAct | ParallelAct)[]): SequenceAct {
    const node = new SequenceAct();

    node.children = createActs(items);

    return node;
}

/**
 * Use ParallelAct as container for parallel Acts.
 * It is Promise.all() like behaviour.
 */
export function parallel(items: (ActDecoratorConstructor | SequenceAct | ParallelAct)[]): ParallelAct {
    const node = new ParallelAct();

    node.activeActs = createActs(items);

    return node;
}